import { FC, c } from 'lib/component-utils'
import Container from 'components/landing/Container'
import Button from 'components/base/Button'

const SellmonitorIntegration: FC = ({ className }) => {
  return (
    <Container className={c`!pb-0 !pt-16 ${className}`}>
      <div className="relative w-full text-base rounded-2xl text-black bg-gradient-to-tr from-[#F5F6F7] to-[#F5F6F7] selection:bg-gray-200">
        <div className="flex w-full items-center gap-8 px-6 py-10 sm:px-14">
          <div className="min-w-0 flex-1">
            <h2 className="text-2xl font-medium">Доверьте CDEK логистику до маркетплейсов</h2>
            <div className="mt-4 space-y-0.5">
              <p className="text-balance">
                FBO и FBS, удобная форма заказа, сдача груза в ПВЗ или курьеру, услуги маркировки и
                переупаковки, хранение груза для доставки в нужный день
              </p>
            </div>
            <Button
              as="a"
              href="https://www.cdek.ru/ru/marketplace/?utm_source=sellmonitor&utm_medium=site&utm_campaign=banner"
              target="_blank"
              rel="noreferrer nofollow"
              theme="primary"
              className="!bg-[#1DB248] hover:brightness-105 focus:ring-offset-gray-900 focus:ring-[#1DB248] mt-8"
            >
              Заключить договор
            </Button>
          </div>
          <div className="hidden shrink-0 lg:block">
            <img
              src="/next/img/landing/cdek.png"
              alt="CDEK"
              className="h-auto w-[283px]"
            />
          </div>
        </div>
      </div>
    </Container>
  )
}

export default SellmonitorIntegration
